import { render } from "./HimawariScreen.vue?vue&type=template&id=ff196ff8&scoped=true&ts=true&lang=pug"
import script from "./HimawariScreen.vue?vue&type=script&lang=ts"
export * from "./HimawariScreen.vue?vue&type=script&lang=ts"

import "./HimawariScreen.vue?vue&type=style&index=0&id=ff196ff8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff196ff8"]])

export default __exports__